export const API_URL = ctxPath + "/.rest/";
export default API_URL;
